import { useState, useEffect } from 'react';
import logo from '../assets/megedLogoTransp.png';

const links = [
    { label: 'ראשי', href: '#home' },
    { label: 'אודות', href: '#about' },
    { label: 'אפליקציית מגדיגיטל', href: '#app' },
    { label: 'תמונות מהמטיילים', href: '#gallery' },
    { label: 'המלצות', href: '#testimonials' },
    { label: 'צור קשר', href: '#contact' },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [active, setActive] = useState('');

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > 20);

            const sections = links.map(l => l.href.replace('#', ''));

            // אם בראש הדף - ראשי פעיל
            if (window.scrollY < 200) {
    setActive('#home');
    return;
  }

            for (let i = sections.length - 1; i >= 0; i--) {
                const el = document.getElementById(sections[i]);
                if (el && window.scrollY >= el.offsetTop - 100) {
                    setActive('#' + sections[i]);
                    break;
                }
            }
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const scrollTo = (id) => {
        if (id === '#home') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
        }
        setMenuOpen(false);
        setActive(id);
    };
    return (
        <>
            <nav className={`fixed top-0 w-full z-50 transition-all duration-300
        ${scrolled
                    ? 'bg-white/95 backdrop-blur-md shadow-card border-b border-brand-blue/10'
                    : 'bg-white/80 backdrop-blur-sm'
                }`}>
                <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">

                    <a href="#home" onClick={(e) => { e.preventDefault(); scrollTo('#home'); }}>
                        <img src={logo} alt="מגד שמיים" className="h-11 w-auto" />
                    </a>

                    {/* Desktop links */}
                    <ul className="hidden md:flex gap-1 list-none">
                        {links.map(({ label, href }) => {
                            const isActive = active === href;
                            return (
                                <li key={href} className="relative">
                                    <button
                                        onClick={() => scrollTo(href)}
                                        className={`relative font-body text-[14px] px-4 py-2.5
                      transition-all duration-200
                      ${isActive
                                                ? 'text-brand-blue font-semibold'
                                                : 'text-gray-500 font-normal hover:text-brand-blue'
                                            }`}
                                    >
                                        {label}

                                        {/* קו תחתון מונפש */}
                                        <span
                                            className={`absolute bottom-1 right-1/2 translate-x-1/2
                         bg-brand-blue rounded-full
                         transition-all duration-300 ease-in-out
                         ${isActive
                                                    ? 'w-6 h-0.5 opacity-100'
                                                    : 'w-1 h-1 rounded-full opacity-30'
                                                }`}
                                        />
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => scrollTo('#contact')}
                            className="hidden md:block bg-brand-blue hover:bg-brand-blue-dark text-white
                         font-body text-[14px] font-semibold px-5 py-2.5 rounded-full
                         transition-all duration-200 hover:scale-105 active:scale-95
                         shadow-sm hover:shadow-card"
                        >
                            השאר פרטים
                        </button>

                        {/* Hamburger */}
                        <button
                            onClick={() => setMenuOpen(!menuOpen)}
                            className="md:hidden flex flex-col gap-1.5 p-2"
                        >
                            <span className={`block w-6 h-0.5 bg-brand-blue transition-all duration-300
                ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
                            <span className={`block w-6 h-0.5 bg-brand-blue transition-all duration-300
                ${menuOpen ? 'opacity-0' : ''}`} />
                            <span className={`block w-6 h-0.5 bg-brand-blue transition-all duration-300
                ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
                        </button>
                    </div>

                </div>

                {/* Mobile menu */}
                <div className={`md:hidden overflow-hidden transition-all duration-300
          ${menuOpen ? 'max-h-96 border-t border-brand-blue/10' : 'max-h-0'}`}>
                    <div className="bg-white/95 backdrop-blur-md px-6 py-4 flex flex-col gap-1">
                        {links.map(({ label, href }) => {
                            const isActive = active === href;
                            return (
                                <button
                                    key={href}
                                    onClick={() => scrollTo(href)}
                                    className={`font-body text-[16px] text-right py-3
                              border-b border-gray-100 last:border-0
                              transition-colors duration-200
                              ${isActive
                                            ? 'text-brand-blue font-semibold'
                                            : 'text-gray-700 font-normal hover:text-brand-blue'
                                        }`}
                                >
                                    {isActive && <span className="ml-2 inline-block w-1.5 h-1.5 rounded-full bg-brand-blue mb-0.5" />}
                                    {label}
                                </button>
                            );
                        })}
                        <button
                            onClick={() => scrollTo('#contact')}
                            className="mt-3 w-full bg-brand-blue text-white font-body font-semibold
                         text-[16px] py-3 rounded-full text-center"
                        >
                            השאר פרטים
                        </button>
                    </div>
                </div>
            </nav>
        </>
    );
}